import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Data } from '@angular/router';
var turf = require('@turf/turf');
import 'leaflet';
import { environment } from 'src/environments/environment';

declare var L: any;

@Component({
  selector: 'app-leaflet-feasibility-preview',
  templateUrl: './leaflet-feasibility-preview.component.html',
  styleUrls: ['./leaflet-feasibility-preview.component.scss']
})
export class LeafletFeasibilityPreviewComponent implements OnInit {

  @Input() target: any = { geoJSON: '', area: 0 };
  taskTarget: any;
  taskid: any;
  taskname: any;
  // coordinates: string;
  opportunity: any;

  coordinates: any[] = [];

  @ViewChild('map', { static: true }) mapContainer!: ElementRef;
  private map!: any;
  zoomLevel = 3;
  mapDistance = 0;
  lattitude = 41.2;
  longitude = 74.66;
  latLngDMS = '';

  constructor(
    private dialogRef: MatDialogRef<LeafletFeasibilityPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
    private el: ElementRef, private renderer: Renderer2,
    private changDetectionRef: ChangeDetectorRef
  ) {
    this.coordinates = [];
    this.taskid = data['taskid'];
    this.taskname = data['taskname'];
    this.taskTarget = JSON.parse(this.data['target']);
    this.opportunity = data['opportunity'];
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.initializeMap();
    this.setupEventListeners();
    this.plotTargetNew('');

    // Selecting the content div
    const contentDiv = document.querySelector('.content');

    if (contentDiv) {
      contentDiv.addEventListener('mouseenter', () => {
        // Disable map interactions when mouse enters the content div
        this.map.dragging.disable();
        this.map.scrollWheelZoom.disable();
        this.map.doubleClickZoom.disable();
        this.map.touchZoom.disable();
        this.map.boxZoom.disable();
        this.map.keyboard.disable();
        this.map.off('mousemove')
      });

      contentDiv.addEventListener('mouseleave', () => {
        // Re-enable map interactions when mouse leaves the content div
        this.map.dragging.enable();
        this.map.scrollWheelZoom.enable();
        this.map.doubleClickZoom.enable();
        this.map.touchZoom.enable();
        this.map.boxZoom.enable();
        this.map.keyboard.enable();
        this.map.on('mousemove', this.handleMouseMove)
        // this.setupEventListeners();
      });
    }
  }

  mapFontColor = 'black';
  
  private initializeMap(): void {
    const isSentinelBaseMapEnabled = environment.enableSentinelBaseMap === 'true';
    this.map = L.map(this.mapContainer.nativeElement, {attributionControl: false, minZoom: isSentinelBaseMapEnabled ? 7 : 1, maxZoom: 18}).setView(
      [this.lattitude, this.longitude],
      this.zoomLevel
    );
    const sentinelLayer = isSentinelBaseMapEnabled
      ? environment.isCopernicusLoad === "true"
        ? L.tileLayer(
            'https://sh.dataspace.copernicus.eu/ogc/wmts/f8b2a869-bd69-4ac6-8791-3443f116fa98' +
              '?SERVICE=WMTS' +
              '&REQUEST=GetTile' +
              '&VERSION=1.0.0' +
              '&LAYER=S2BASEMAP-LAYER' +
              '&STYLE=default' +
              '&FORMAT=image/png' +
              '&TILEMATRIXSET=PopularWebMercator256' +
              '&TILEMATRIX={z}' +
              '&TILEROW={y}' +
              '&TILECOL={x}',
            {
              tileSize: 256,
              noWrap: true
            }
          )
        : L.tileLayer(
            'https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg',
            {
              tileSize: 256,
              noWrap: true
            }
          )
      : null;
    const baselayers = {
      Openstreetmap: L.tileLayer(
        'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
      ),
      ...(isSentinelBaseMapEnabled && sentinelLayer ? { Sentinel: sentinelLayer } : {})
    };
    let target: any;
    // this.viewHome();

    L.Icon.Default.mergeOptions({
      iconUrl: '../../../assets/map-icons/marker-icon.png',  
      iconSize: [25, 41],                   
      iconAnchor: [12, 41],                  
      popupAnchor: [1, -34],                
      shadowUrl: '../../../assets/map-icons/marker-shadow.png',  
      shadowSize: [41, 41],                   
      shadowAnchor: [12, 41]              
    });

    var overlays = {};
    L.control.layers(baselayers, overlays, {
      collapsed: false,  // Optionally control whether the control is collapsed by default
      position: 'topright'  // Optionally set the position of the control
    }).addTo(this.map);

    var myAttrControl = L.control.attribution().addTo(this.map);
    myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
    const sentinel2Layer = isSentinelBaseMapEnabled ? sentinelLayer : null;
    if (isSentinelBaseMapEnabled && sentinel2Layer) {
      sentinel2Layer.addTo(this.map);
      this.map.setMinZoom(7);
      this.map.setMaxZoom(18);
    } else {
      baselayers['Openstreetmap'].addTo(this.map);
      this.map.setMinZoom(1);
      this.map.setMaxZoom(18);
    }

    setTimeout(() => {
      const layersControlElement = document.querySelector('.leaflet-control-layers');
      if(layersControlElement){
        const container = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        container.classList.remove('leaflet-control-layers-expanded');
      }
    }, 0);

    if (isSentinelBaseMapEnabled && baselayers['Sentinel']) {
      baselayers['Sentinel'].addTo(this.map);
    }

    this.map.on('baselayerchange', (event) => {
      const container = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (container) {
        container.classList.remove('leaflet-control-layers-expanded');
      }
      const element = document.querySelector('#homeButton');
      if (element) {
        this.renderer.setStyle(element, 'z-index', '500');
      }

      if (event.name === "Openstreetmap") {
        this.mapFontColor = 'black';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
        myAttrControl.addAttribution('&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers');
        this.map.setMinZoom(1);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 1) {
        this.map.setZoom(1);
        }
        if (this.map.getZoom() > 18) {
        this.map.setZoom(18); 
        }
        if (isSentinelBaseMapEnabled && sentinel2Layer && this.map.hasLayer(sentinel2Layer)) {
          this.map.removeLayer(sentinel2Layer);
        }
    } else if (isSentinelBaseMapEnabled && event.name === 'Sentinel') {
        this.mapFontColor = 'white';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution('Data by &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, under <a href="https://opendatacommons.org/licenses/odbl/">ODbL.</a>');
        myAttrControl.addAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
        this.map.setMinZoom(7);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 7) {
        this.map.setZoom(7);
        }
       if (this.map.getZoom() > 18) {
       this.map.setZoom(18);
       }
     }
    });

    
    document.querySelector('.leaflet-control-layers-toggle')?.addEventListener('click', (e) => {
      this.removeHighlight();
      let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
      layerBtn.classList.add('highlight-border');
      if(document.querySelector('.leaflet-control-layers-expanded')) {
        document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:-34px !important')
      }
    })

    this.map.on('click', () => {
      this.removeHighlight();
      document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:0px !important')
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (controlContainer?.classList?.contains('leaflet-control-layers-expanded')) {
          controlContainer?.classList?.remove('leaflet-control-layers-expanded');
      }
    });



    const mapContainer: any = document.getElementById('map');
    const zoomDiv = document.getElementById('zoomDiv');
    mapContainer.appendChild(zoomDiv);

    this.map.removeControl(this.map.zoomControl);
    const zoomControl = new L.Control.Zoom({ position: 'bottomright' });
    zoomControl.addTo(this.map);

    this.calculateZoomLevel();

    this.changDetectionRef.detectChanges();
  }

  private setupEventListeners(): void {
    this.map.on('zoomend', this.HandleZoomEnd);
    this.map.on('mousemove', this.handleMouseMove);
    this.map.on('move', this.handleMapMove);
  }

  removeHighlight() {
    let homeBtn: any = document.querySelector('#homeButton');
    if(homeBtn) {
      homeBtn.classList.remove('highlight-border');
    }
    let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
    if(layerBtn) {
      layerBtn.classList.remove('highlight-border');
    }
  }

  HandleZoomEnd = () => {
    this.calculateZoomLevel();
  };

  calculateZoomLevel = () => {
    this.zoomLevel = this.map.getZoom();
    const bounds = this.map.getBounds();
    const distance = bounds.getSouthWest().distanceTo(bounds.getNorthEast());
    this.mapDistance = distance / 1000;
  };

  handleMouseMove = (e: any) => {
    this.latLngDMS = this.decimalToDMS(e.latlng.lat, e.latlng.lng);
  };

  handleMapMove = (e: any) => {
    this.updateDivPosition();
  }

  customDiv: any;
  updateDivPosition = () => {
    this.markersAndDivs.forEach((item, index) => {
      if (item.layer) {
        var point = this.map.latLngToContainerPoint(item.layer);
        this.markersAndDivs[index].div.style.left = point.x + 'px';
        this.markersAndDivs[index].div.style.top = point.y - 3 + 'px';
      }
    });
  }

  decimalToDMS(lat: number, lng: number): string {
    const convert = (decimal: number) => {
      const absolute = Math.abs(decimal);
      const degrees = Math.floor(absolute);
      const minutesNotTruncated = (absolute - degrees) * 60;
      const minutes = Math.floor(minutesNotTruncated);
      const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
      return `${degrees}° ${minutes}' ${seconds}"`;
    };
    const latitude = convert(lat) + (lat >= 0 ? ' N' : ' S');
    const longitude = convert(lng) + (lng >= 0 ? ' E' : ' W');
    return `Lng:${longitude}, Lat:${latitude}`;
  }

  eventLayers: any[] = [];
  viewHome(event) {
    this.removeHighlight();

    let layerList: any = document.querySelector('.leaflet-control-layers-expanded');
    if(layerList) {
      layerList.classList.remove('leaflet-control-layers-expanded');
    }

    document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:0px !important')

    let homeBtn: any = document.querySelector('#homeButton');
    homeBtn.classList.add('highlight-border');
    let target: any;
    if (this.taskTarget) {
      const fpPoints = this.opportunity.footprint[0].toString().split(',').map(Number);
      const latLngs: any[] = [];
      for (let i = 0; i < fpPoints.length; i += 2) {
        latLngs.push([fpPoints[i + 1], fpPoints[i]]);
      }

      
      
      if (this.taskTarget.type === 'Polygon') {
        const fpPos = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
          this.coordinates = fpPos;
        let modifiedArray = this.taskTarget.coordinates[0].map((sub) => {
          return [sub[1], sub[0]];
        });

        var polygon = L.polygon(modifiedArray, { color: 'red' }).addTo(
          this.map
        );
        this.map.fitBounds(polygon.getBounds());
      } else if (this.taskTarget?.length > 1) {

          if (this.taskTarget.type === 'Point') {
            this.generateMarkerNumber(this.taskTarget)
          }
        
        this.createGeoJSONFile(this.taskTarget);
        if(this.geoJsonLayer) {
          this.map.fitBounds(this.geoJsonLayer.getBounds());
        }
      } else if (this.taskTarget.type === 'Point') {
        const fpPos = this.taskTarget.coordinates;
        this.coordinates = fpPos;
        const lng = fpPos[0],
          lat = fpPos[1];
        this.map.setView([lat, lng], 3);
        L.marker([lat, lng]).addTo(this.map);
      }

      const polyline = L.polyline(latLngs, { color: 'yellow' }).addTo(this.map);
      this.map.fitBounds(polyline.getBounds());
    }

    event?.stopPropagation()
  }

  setMapView(lat, lng) {
    this.map.setView([lat, lng], this.zoomLevel);
  }

  
  plotTargetNew(event: any) {
      this.viewHome(event);
  }

  createGeoJsonNew(features: any[]) {
    const geoJSON = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };
    return geoJSON
  }

  geoJsonLayer: any;
  createGeoJSONFile(features: any[]) {
    const geoJSON = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };

    this.geoJsonLayer = L.geoJSON(geoJSON).addTo(this.map);
  }

  markersAndDivs: any[] = [];
  generateMarkerNumber(features: any[]) {
    if(features.length > 1) {
      features.forEach((layer, i) => {
        let customDiv: any;
        let index = i+1;
        customDiv = document.createElement('div');
        customDiv.id = 'custom-div-' + index;
        customDiv.style.position = 'absolute';
        customDiv.style.zIndex = '500';
        customDiv.innerHTML = ''+index;
        customDiv.style.fontWeight = '700';
        customDiv.style.fontSize = '18px';
        customDiv.style.color = 'white';
        // Append the div to the map container
        if (document) {
          (document as any).getElementById('map').appendChild(customDiv);
        }
        var point = this.map.latLngToContainerPoint([layer.coordinates[1], layer.coordinates[0]]);
        customDiv.style.left = point.x + 'px';
        customDiv.style.top = point.y - 3 + 'px';

        this.markersAndDivs[i] = {
          div : customDiv,
          layer: [layer.coordinates[1], layer.coordinates[0]]
        }
      })
    }
  }

  onKeyPress(e: any, msg: string) {
    if (e.key === 'Enter') {
      this.onNoClick(msg);
    }
  }
  onNoClick(msg: any): void {
    this.dialogRef.close('Done');   
  }



}
